module.exports = __webpack_public_path__ + "assets/img/5626-ke.svg";